module.exports = __webpack_public_path__ + "static/img/bg0.2741e9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg0.jpg
// module id = 7+3n
// module chunks = 1